module.exports = __webpack_public_path__ + "static/img/icon-ellipse.e4e72166.svg";